// extracted by mini-css-extract-plugin
export var shake = "_n-0";